"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4190],{

/***/ 5503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageWithFallback; }
/* harmony export */ });
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);



function ImageWithFallback(_ref) {
  var src = _ref.src,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "" : _ref$alt,
      className = _ref.className,
      _ref$fallback = _ref.fallback;
  _ref$fallback = _ref$fallback === void 0 ? {} : _ref$fallback;
  var _ref$fallback$size = _ref$fallback.size,
      size = _ref$fallback$size === void 0 ? "640x16:9" : _ref$fallback$size,
      _ref$fallback$bg = _ref$fallback.bg,
      bg = _ref$fallback$bg === void 0 ? "eeeeee" : _ref$fallback$bg,
      _ref$fallback$color = _ref$fallback.color,
      color = _ref$fallback$color === void 0 ? "333333" : _ref$fallback$color,
      _ref$fallback$text = _ref$fallback.text,
      text = _ref$fallback$text === void 0 ? alt || "DaMaMaps" : _ref$fallback$text,
      fallbackSrc = _ref$fallback.src;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!src),
      error = _useState[0],
      setError = _useState[1];

  fallbackSrc = fallbackSrc || "https://dummyimage.com/".concat(size, "/").concat(bg, "/").concat(color, "&text=").concat(encodeURIComponent(text));
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
    src: error ? fallbackSrc : src,
    layout: 'fill',
    alt: alt,
    className: className,
    onError: function onError() {
      return setError(true);
    }
  });
}

/***/ }),

/***/ 4656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Rating; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84887);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62361);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44612);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57851);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);




var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function Rating(_ref) {
  var className = _ref.className,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({
    icon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
      icon: _fortawesome_pro_solid_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_5__/* .faStar */ .T
    }),
    emptyIcon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
      icon: _fortawesome_pro_regular_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_6__/* .faStar */ .T
    }),
    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_7__/* .twMerge */ .m)('text-primary text-sm shrink-0', className)
  }, props));
}

/***/ }),

/***/ 34101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faBagShopping.js
var faBagShopping = __webpack_require__(90010);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCertificate.js
var faCertificate = __webpack_require__(48256);
// EXTERNAL MODULE: ./components/ImageWithFallback.js
var ImageWithFallback = __webpack_require__(5503);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Rating.js
var Rating = __webpack_require__(4656);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./data/config.json
var config = __webpack_require__(56513);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(57731);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 5 modules
var Select = __webpack_require__(10315);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 2 modules
var MenuItem = __webpack_require__(30431);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDropUp.js
var ArrowDropUp = __webpack_require__(29217);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDropDown.js
var ArrowDropDown = __webpack_require__(45111);
// EXTERNAL MODULE: ./node_modules/@mui/material/OutlinedInput/OutlinedInput.js + 2 modules
var OutlinedInput = __webpack_require__(37058);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(3580);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./components/modals/OrderModal.js

















function OrderModal(props) {
  var modalOpen = props.modalOpen,
      setModalOpen = props.setModalOpen,
      product = props.product;

  var _useState = (0,react.useState)(true),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react.useState)(1),
      amount = _useState2[0],
      setAmount = _useState2[1];

  var locations = (0,es/* useSelector */.v9)(function (state) {
    return state.map.locations;
  });

  var _useState3 = (0,react.useState)(''),
      msg = _useState3[0],
      setMsg = _useState3[1];

  var _useState4 = (0,react.useState)({
    id: 0,
    name: ''
  }),
      pickupLocation = _useState4[0],
      setPickupLocation = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      availableLocations = _useState5[0],
      setAvailableLocations = _useState5[1];

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var initAvailableLocations = function initAvailableLocations() {
    if (!!product.locations && product.locations.length > 0 && typeof product.locations !== 'string') {
      var tempLocations = product.locations.map(function (item) {
        if (item.id) {
          var temp = locations.find(function (location) {
            return location.id === item;
          });

          if (!!temp) {
            return temp;
          } else {
            return null;
          }
        } else {
          return null;
        }
      });
      setAvailableLocations(tempLocations.filter(function (item) {
        return item !== null;
      }));
    }
  };

  (0,react.useEffect)(function () {
    setLoading(false);
    initAvailableLocations();
  }, []);
  (0,react.useEffect)(function () {
    initAvailableLocations();
  }, [locations]);
  (0,react.useEffect)(function () {
    if (availableLocations.length > 0) {
      setPickupLocation(availableLocations[0]);
    }
  }, [availableLocations]);

  var handleOrder = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var user, res;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return localStorage.getItem('user');

            case 2:
              user = _context.sent;
              _context.next = 5;
              return (0,helper.addToBag)(user, {
                productInfo: product,
                amount: amount
              }, pickupLocation.id);

            case 5:
              res = _context.sent;

              if (res.success) {
                handleCancel();
              } else {
                setMsg(res.msg);
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleOrder() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleCancel = function handleCancel() {
    setModalOpen(false);
  };

  var handleChange = function handleChange(e) {
    setAmount(e.target.value);
  };

  var minusOne = function minusOne() {
    setAmount(amount - 1);
  };

  var addOne = function addOne() {
    setAmount(amount + 1);
  };

  var handleLocationChange = function handleLocationChange(e) {
    setPickupLocation(e.target.value);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [loading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: "fixed z-[1299] bg-gray-100 inset-0"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* default */.Z, {
      open: modalOpen,
      onClose: function onClose(e) {
        return setModalOpen(false);
      },
      className: 'flex p-6',
      componentsProps: {
        backdrop: {
          className: "bg-gray-20"
        }
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "bg-white m-auto shadow-lg p-8 rounded max-w-md outline-0 w-full flex flex-col items-center text-center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          className: "w-full mb-6 flex text-start font-bold ",
          children: product.name
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "flex items-center justify-center w-full gap-4 mb-5",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "text-black-500 font-bold pr-5",
              children: "$".concat(product.price_compare > 0 ? product.price_compare : product.price)
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "text-gray-500 ",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OutlinedInput/* default */.Z, {
                className: "p-0",
                size: "small",
                type: 'number',
                value: amount,
                onChange: handleChange,
                endAdornment: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputAdornment/* default */.Z, {
                  position: "end",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "flex flex-col inline-block",
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* default */.Z, {
                      className: "m-0 p-0 rounded-none",
                      "aria-label": "toggle password visibility",
                      onClick: addOne,
                      edge: "end",
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDropUp/* default */.Z, {})
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* default */.Z, {
                      className: "m-0 p-0 rounded-none",
                      "aria-label": "toggle password visibility",
                      onClick: minusOne,
                      edge: "end",
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDropDown/* default */.Z, {})
                    })]
                  })
                })
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "flex w-full gap-4 mb-10 justify-center items-center",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "text-black-500 pr-5",
              children: t('home:pickupLocation')
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "flex py-4 items-center",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.Z, {
                value: pickupLocation.name,
                onChange: handleLocationChange,
                size: 'small',
                className: "w-52 text-sm bg-white ml-auto",
                children: availableLocations.length > 0 && availableLocations.map(function (loc) {
                  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
                    value: loc.name,
                    children: loc.name
                  }, loc.id);
                })
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "flex w-full gap-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              variant: "outlined",
              fullWidth: true,
              onClick: handleOrder,
              children: t('home:addToBag')
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              className: '!bg-[#108085]',
              variant: "contained",
              fullWidth: true,
              onClick: handleCancel,
              children: t('home:cancel')
            })]
          }), msg !== '' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "text-black-500 ",
            children: msg
          }) : null]
        })]
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/cards/ProductCard.js



var _excluded = ["data"];














function ProductCard(_ref) {
  var product = _ref.data,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var plain = props.plain,
      showDistance = props.showDistance,
      hideCTA = props.hideCTA,
      baseUrl = props.baseUrl,
      type = props.type,
      brandInfo = props.brandInfo;

  var _useState = (0,react.useState)(''),
      link = _useState[0],
      setLink = _useState[1];

  var _useState2 = (0,react.useState)('Name'),
      productName = _useState2[0],
      setProductName = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      modalOpen = _useState3[0],
      setModalOpen = _useState3[1];

  var user = (0,es/* useSelector */.v9)(function (state) {
    return state.auth.user;
  });

  var orderNow = function orderNow() {
    setModalOpen(true);
  };

  var updateLink = function updateLink() {
    var temp = !!baseUrl ? type === 'Brand_Product' ? "".concat(baseUrl).concat(product.category, "/").concat(encodeURIComponent(productName), "/").concat(product.id) : type === 'Brand_Service' ? "".concat(baseUrl).concat(encodeURIComponent(productName), "/").concat(product.id) : "".concat(baseUrl, "/").concat(encodeURIComponent(productName), "/").concat(product.id) : type === 'Product' ? "".concat(product['__typename'] === 'Product' ? 'products' : 'services', "/").concat(!!product.category ? product.category : '', "/").concat(encodeURIComponent(productName), "/").concat(product.id) : '';
    setLink(temp);
  }; // const checkUsers = async () => {
  //   let user = await localStorage.getItem('user')
  // }


  (0,react.useEffect)(function () {
    updateLink();

    if (product.slug !== '') {
      setProductName(product.slug);
    }
  }, []);
  (0,react.useEffect)(function () {
    updateLink();
  }, [productName]);

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return !!product ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (0,clsx_m/* default */.Z)(['flex flex-col relative', !plain && 'shadow-md rounded overflow-hidden p-4']),
    children: [!plain && product.brand_verified && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
      icon: faCertificate/* faCertificate */.U,
      className: 'text-primary absolute top-1 right-4 z-10'
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      href: link,
      passHref: true,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,clsx_m/* default */.Z)(["relative after:content-[''] after:block", 'after:pb-[75%] mb-2']),
        children: !!product.images ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWithFallback/* default */.Z, {
          src: product.images[0],
          alt: product.name,
          className: "object-cover transition hover:brightness-105 cursor-pointer"
        }) : null
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "text-xs text-gray-500 mb-1 flex",
      children: [type === 'Product' ? config/* product.category_mapping */.O7.Wn[product.category] === undefined ? '' : t("home:".concat(product.category)) : config/* service.category_mapping */.Xn.W[product.category] === undefined ? ' ' : t("home:".concat(product.category)), showDistance && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        className: "ml-auto text-primary font-semibold",
        children: "".concat(product.location.distance, " ").concat(t('home:distance'))
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      href: link,
      passHref: true,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
          className: "font-bold text-base mb-1 min-h-[80px] flex items-center",
          children: product.name
        })
      })
    }), !!product.brand && product.brand.name !== '' ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "text-xs text-gray-500 mb-2",
      children: ["By ", product.brand.name]
    }) : !!brandInfo ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "text-xs text-gray-500 mb-2",
      children: ["By ", brandInfo.name]
    }) : null, (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "flex flex-grow flex-nowrap items-center mb-4 text-gray-500",
      children: [product.rating ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          className: "text-xs mr-2",
          children: product.rating.toFixed(1)
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Rating/* default */.Z, {
          value: product.rating || 5,
          precision: 0.5,
          readOnly: true,
          className: 'mr-2'
        })]
      }) : null, product.reviews_count ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "text-xs",
        children: ["(", product.reviews_count, ")"]
      }) : null]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: "text-xs text-gray-500",
      children: product.weight === 'Each' ? t('home:each') : product.weight
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "flex mb-2",
      children: [product.price > 0 ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "font-semibold text-2xl leading-0",
        children: ["$", product.price_compare > 0 ? product.price_compare : product.price]
      }) : null, product.deal && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "ml-auto text-gray-500 font-semibold line-through leading-normal",
        children: ["$", product.price_compare > 0 ? product.price : '']
      })]
    }), !hideCTA && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* default */.Z, {
      onClick: orderNow,
      variant: 'contained',
      size: 'small',
      className: user.isLoggedIn ? 'shadow-none !bg-[#108085]' : null,
      disabled: !user.isLoggedIn,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
        icon: faBagShopping/* faBagShopping */.Cd,
        className: 'mr-2'
      }), t('home:button_ordernow')]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderModal, {
      modalOpen: modalOpen,
      setModalOpen: setModalOpen,
      product: product
    })]
  }, product.slug) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
      children: t('home:loading')
    })
  });
}

/***/ }),

/***/ 74190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductListing; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSearch.js
var faSearch = __webpack_require__(367);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCertificate.js
var faCertificate = __webpack_require__(48256);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSliders.js
var faSliders = __webpack_require__(46679);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 6 modules
var Checkbox = __webpack_require__(85071);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/OutlinedInput/OutlinedInput.js + 2 modules
var OutlinedInput = __webpack_require__(37058);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 5 modules
var Select = __webpack_require__(10315);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 2 modules
var MenuItem = __webpack_require__(30431);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./components/cards/ProductCard.js + 1 modules
var ProductCard = __webpack_require__(34101);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(3580);
// EXTERNAL MODULE: ./data/config.json
var config = __webpack_require__(56513);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(57731);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(75503);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./components/CollapseList.js













function CustomizedList(props) {
  var name = props.name,
      subList = props.subList,
      filter = props.filter,
      handleFilterChange = props.handleFilterChange,
      t = props.t,
      category = props.category,
      index = props.index;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  (0,react.useEffect)(function () {
    if (!!category) {
      var parents = config/* product.categories.map */.O7.bd.map(function (item) {
        return item.slug;
      });
      var openStatus = parents.map(function (item) {
        return category.includes(item);
      });
      setOpen(openStatus[index]);
    }
  }, [category]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      display: 'flex'
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
      sx: {
        pb: open ? 2 : 0
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListItemButton/* default */.Z, {
        alignItems: "flex-start",
        onClick: function onClick() {
          return setOpen(!open);
        },
        sx: {
          // px: 3,
          // pt: 2.5,
          // pb: open ? 0 : 2.5,
          '&:hover, &:focus': {
            '& svg': {
              opacity: open ? 1 : 0
            }
          }
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemText/* default */.Z, {
          primary: name,
          primaryTypographyProps: {
            fontSize: 14,
            fontWeight: open ? 'bold' : 'medium',
            lineHeight: '20px',
            mb: '2px' // color: open ? '#108085' : 'black'

          },
          secondaryTypographyProps: {
            noWrap: true,
            fontSize: 12,
            lineHeight: '16px',
            color: 'black'
          },
          sx: {
            my: 0
          }
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyboardArrowDown/* default */.Z, {
          sx: {
            mr: -1,
            opacity: 0,
            transform: open ? 'rotate(-180deg)' : 'rotate(0)',
            transition: '0.2s'
          }
        })]
      }), open && subList.map(function (item) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'text-sm',
            children: item.name === t('home:allAbove') ? t('home:allAbove') : t("home:".concat(item.slug))
          }),
          className: 'flex items-center -mb-1',
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            checked: !!filter.categories ? filter.categories.includes(item.slug) : false,
            onChange: function onChange(e) {
              return handleFilterChange('categories', item.slug);
            },
            size: 'small',
            className: 'text-primary-dark'
          })
        }, item.slug + item.name);
      })]
    })
  });
}
;// CONCATENATED MODULE: ./components/views/ProductListing.js







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var SORT_OPTIONS = config/* product.sort */.O7.DY;
var STRAIN_TYPES = config/* product.strainType */.O7.Vc;
var PRICE_RANGES = config/* product.priceRange */.O7.GD;
var WEIGHTS = config/* product.weight */.O7.jQ;
var filter_key_map = {
  categories: 'category',
  deals: 'deal',
  brandVerified: 'brand_verified',
  brands: 'brand',
  priceRanges: 'price',
  weights: 'weight',
  strainTypes: 'strain_type'
};
function ProductListing(props) {
  var products = props.products,
      deals = props.deals,
      brands = props.brands,
      baseUrl = props.baseUrl,
      type = props.type,
      _sort = props._sort,
      _filter = props._filter,
      _page = props._page,
      category = props.category;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(SORT_OPTIONS.find(function (s) {
    return s.sort.sortBy === _sort.sortBy && s.sort.order === _sort.order;
  }) || SORT_OPTIONS[0]),
      sort = _useState[0],
      setSort = _useState[1];

  var handleSortChange = function handleSortChange(event) {
    // console.log('sort changing: ', event)
    setSort(event.target.value);
    var res = sortProduct(event.target.value, filteredProducts);
    setFilteredProducts(res);
  };

  var _useState2 = (0,react.useState)(_filter),
      filter = _useState2[0],
      setFilter = _useState2[1];

  var _useState3 = (0,react.useState)(products),
      filteredProducts = _useState3[0],
      setFilteredProducts = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      searchInput = _useState5[0],
      setSearchInput = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isMobile = _useState6[0],
      setIsMobile = _useState6[1];

  var _useState7 = (0,react.useState)([false, false, false, false, false]),
      parentCategoriesOpenList = _useState7[0],
      setParentCategoriesOpenList = _useState7[1];

  var _useState8 = (0,react.useState)([]),
      localCategories = _useState8[0],
      setLocalCategories = _useState8[1];

  var checkCategories = function checkCategories(current) {
    var global_categories = type === 'Product' ? config/* product.categories */.O7.bd : config/* service.categories */.Xn.b;
    setLocalCategories(global_categories);

    if (type === 'Product' && !filter.categories.includes(current)) {
      filter.categories.push(current);
    }
  };

  (0,react.useEffect)(function () {
    checkCategories(category);
  }, [category]);

  var handleChangeSearchInput = function handleChangeSearchInput(e) {
    setSearchInput(e.target.value);
  };

  var initList = function initList() {
    if (type === 'Service' && _filter['categories'].length > 0) {
      handleFilterChange('categories', _filter['categories']);
    }
  };

  (0,react.useEffect)(function () {
    console.log('at product listing: ', brands);
    initList();
    checkCategories();
    setLoaded(true);
  }, []);

  var handleFilterChange = function handleFilterChange(field, value) {
    console.log('filter changed: ', field, value);

    switch (field) {
      case 'deals':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          deals: lodash_default().xor(filter.deals, [value])
        }));
        break;

      case 'categories':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          categories: lodash_default().xor(filter.categories, [value])
        }));
        break;

      case 'brandVerified':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          brandVerified: value
        }));
        break;

      case 'brands':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          brands: lodash_default().xor(filter.brands, [value])
        }));
        break;

      case 'strainTypes':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          strainTypes: lodash_default().xor(filter.strainTypes, [value])
        }));
        break;

      case 'priceRanges':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          priceRanges: (0,helper.toggleArray)(filter.priceRanges, value)
        }));
        break;

      case 'weights':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          weights: lodash_default().xor(filter.weights, [value])
        }));
        break;
    }
  };

  var handleSearch = function handleSearch() {
    if (searchInput === '') {
      var res = filterProduct(filter, products);
      setFilteredProducts(res);
    } else {
      var temp = filteredProducts.filter(function (item) {
        return item.name.toLowerCase().includes(searchInput.toLowerCase());
      });
      setFilteredProducts(temp);
    }
  };

  var clearAll = function clearAll() {
    setSearchInput('');
    var tempFilter = _filter;
    tempFilter.categories = '';
    setFilter(tempFilter);
  };

  var filterProduct = function filterProduct(localFilter, localProducts) {
    if (localFilter.categories[0] === undefined) {
      localFilter.categories = [];
    }

    if (JSON.stringify(localFilter) !== '{}') {
      var _loop = function _loop(key) {
        if (localFilter.hasOwnProperty(key)) {
          // console.log('started: ', key, localFilter[key], localFilter[key].length > 0)
          if (localFilter[key].length > 0 || typeof localFilter[key] === 'boolean') {
            if (key === 'brandVerified') {
              if (localFilter[key] === true) {
                localProducts = localProducts.filter(function (item) {
                  return item[filter_key_map[key]] === true;
                });
              }
            } else if (key === 'categories' || key === 'brands') {
              if (type === 'Service') {
                if (key === 'categories') {
                  if (localFilter[key].length > 0) {
                    var tempList = [];

                    var _loop2 = function _loop2(i) {
                      var list = localProducts.filter(function (item) {
                        return item.category === localFilter[key][i];
                      });
                      tempList = tempList.concat(list);
                    };

                    for (var i = 0; i < localFilter[key].length; i++) {
                      _loop2(i);
                    }

                    localProducts = tempList;
                  }
                }
              } else {
                var _tempList = [];

                if (key === 'categories') {
                  var _loop3 = function _loop3(_i) {
                    var list = localProducts.filter(function (item) {
                      // console.log('checking item slug: ', item, item[filter_key_map[key]])
                      if (!!item[filter_key_map[key]]) {
                        // console.log('checking here: ', item, filter_key_map[key], item[filter_key_map[key]])
                        if (item[filter_key_map[key]].includes(localFilter[key][_i])) {
                          return item;
                        }
                      }
                    });
                    _tempList = _tempList.concat(list);
                  };

                  for (var _i = 0; _i < localFilter[key].length; _i++) {
                    _loop3(_i);
                  }

                  localProducts = _tempList;
                } else {
                  var _loop4 = function _loop4(_i2) {
                    var list = localProducts.filter(function (item) {
                      // console.log('checking item slug: ', item, item[filter_key_map[key]])
                      if (!!item[filter_key_map[key]]) {
                        // console.log('checking here: ', localFilter[key], item.brand.id)
                        if (item.brand.id.toString() === localFilter[key][_i2]) {
                          return item;
                        }
                      }
                    });
                    _tempList = _tempList.concat(list);
                  };

                  for (var _i2 = 0; _i2 < localFilter[key].length; _i2++) {
                    _loop4(_i2);
                  }

                  localProducts = _tempList;
                }
              }
            } else if (key === 'priceRanges') {
              var _tempList2 = [];

              var _loop5 = function _loop5(_i3) {
                var list = localProducts.filter(function (item) {
                  return item.price >= localFilter[key][_i3].min && item.price < localFilter[key][_i3].max;
                });
                _tempList2 = _tempList2.concat(list);
              };

              for (var _i3 = 0; _i3 < localFilter[key].length; _i3++) {
                _loop5(_i3);
              }

              localProducts = _tempList2;
            } else {
              localProducts = localProducts.filter(function (item) {
                if (localFilter[key].includes(item[filter_key_map[key]])) {
                  return item;
                }
              });
            }
          }
        }
      };

      for (var key in localFilter) {
        _loop(key);
      }
    } else {
      console.log('caught it !');
    }

    console.log('localFiltered: ', localProducts.length);
    return localProducts;
  };

  var sortProduct = function sortProduct(localSort, localProducts) {
    return (0,helper.sortByItem)(localProducts, localSort.sort.sortBy, localSort.sort.order);
  };

  (0,react.useEffect)(function () {
    console.log('filtered products: ', filteredProducts);
  }, [filteredProducts]);
  (0,react.useEffect)(function () {
    if (loaded) {
      var temp = filterProduct(filter, products);
      console.log('sorting : ', sort, temp);
      var res = sortProduct(sort, temp);
      setFilteredProducts(res);
    }
  }, [filter, loaded, sort, products]);
  (0,react.useEffect)(function () {
    if (searchInput === '') {
      handleSearch();
    }
  }, [searchInput]);

  var _useState9 = (0,react.useState)(false),
      mobileOpen = _useState9[0],
      setMobileOpen = _useState9[1];

  (0,react.useEffect)(function () {
    if (loaded) {
      setIsMobile((0,helper.checkMobile)());
    }
  }, [loaded]);

  var handleDrawerToggle = function handleDrawerToggle() {
    setMobileOpen(function (prevState) {
      return !prevState;
    });
  };

  var drawerWidth = 240;

  var drawer = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
    className: "p-5",
    sx: {
      textAlign: 'center'
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      variant: 'text',
      className: 'ml-auto w-auto',
      onClick: clearAll,
      children: t('home:clearall')
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "mb-4 ",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "font-semibold text-sm mb-2",
        children: t('home:filter_category')
      }), localCategories.map(function (c) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'text-sm',
            children: t("home:".concat(c.slug))
          }),
          className: 'flex items-center -mb-1',
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            checked: !!filter.categories ? filter.categories.includes(c.slug) : false,
            onChange: function onChange(e) {
              return handleFilterChange('categories', c.slug);
            },
            size: 'small',
            className: 'text-primary-dark'
          })
        }, c.slug);
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "mb-4",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "font-semibold text-sm mb-2",
        children: t('home:amenities_BrandVerified')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
        label: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
          className: 'text-sm',
          children: [t('home:amenities_BrandVerified'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
            icon: faCertificate/* faCertificate */.U,
            className: 'ml-2 text-primary'
          })]
        }),
        className: 'flex items-center -mb-1',
        control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
          checked: filter.brandVerified,
          onChange: function onChange(e) {
            return handleFilterChange('brandVerified', !filter.brandVerified);
          },
          size: 'small',
          className: 'text-primary-dark'
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "mb-4",
      children: [brands && brands.length > 0 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "font-semibold text-sm mb-2",
        children: t('home:Brands')
      }) : null, brands && brands.length > 0 ? brands.map(function (b) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'text-sm',
            children: b.name
          }),
          className: 'flex items-center -mb-1',
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            checked: !!filter.brands ? filter.brands.includes(b.id) : false,
            onChange: function onChange(e) {
              return handleFilterChange('brands', b.id);
            },
            size: 'small',
            className: 'text-primary-dark'
          })
        }, b.slug);
      }) : null]
    }), type === 'Product' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "mb-4",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "font-semibold text-sm mb-2",
        children: t('home:filter_strainType')
      }), STRAIN_TYPES.map(function (t) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'text-sm',
            children: t.label
          }),
          className: 'flex items-center -mb-1',
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            checked: !!filter.strainTypes ? filter.strainTypes.includes(t.value) : false,
            onChange: function onChange(e) {
              return handleFilterChange('strainTypes', t.value);
            },
            size: 'small',
            className: 'text-primary-dark'
          })
        }, t.value);
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "mb-4",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "font-semibold text-sm mb-2",
        children: t('home:filter_priceRange')
      }), PRICE_RANGES.map(function (r) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'text-sm',
            children: "".concat(r.min === 0 ? t('home:under') : '$' + r.min).concat(r.min === 0 || r.max === 'Infinity' ? ' ' : ' - ').concat(r.max === 'Infinity' ? t('home:infinity') : '$' + r.max)
          }),
          className: 'flex items-center -mb-1',
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            checked: !!filter.priceRanges ? filter.priceRanges.includes(r) : false,
            onChange: function onChange(e) {
              return handleFilterChange('priceRanges', r);
            },
            size: 'small',
            className: 'text-primary-dark'
          })
        }, "".concat(String(r.min), "-").concat(String(r.max)));
      })]
    }), type === 'Product' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "mb-4",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "font-semibold text-sm mb-2",
        children: t('home:filter_weight')
      }), WEIGHTS.map(function (w) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'text-sm',
            children: w === 'Each' ? t('home:each') : w
          }),
          className: 'flex items-center -mb-1',
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            checked: !!filter.weights ? filter.weights.includes(w) : false,
            onChange: function onChange(e) {
              return handleFilterChange('weights', w);
            },
            size: 'small',
            className: 'text-primary-dark'
          })
        }, w);
      }) // <Checkbox
      //   checked={!!filter.brands ? filter.brands.includes(b.id) : false}
      //   onChange={e => handleFilterChange('brands', b.id)}
      //   size={'small'} className={'text-primary-dark'}
      // />
      ]
    })]
  });

  var renderMobileFilter = function renderMobileFilter() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "w-auto",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IconButton/* default */.Z, {
          color: "inherit",
          "aria-label": "open drawer",
          edge: "start",
          onClick: handleDrawerToggle,
          sx: {
            display: {
              sm: 'none'
            }
          },
          className: "flex flex-row justify-start",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
            icon: faSliders/* faSliders */.cR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'ml-2 font-semibold min-w-[32px]',
            children: t('home:filter')
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
        component: "nav",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Drawer/* default */.ZP // container={container}
        , {
          variant: "temporary",
          open: mobileOpen,
          onClose: handleDrawerToggle,
          ModalProps: {
            keepMounted: true // Better open performance on mobile.

          },
          sx: {
            display: {
              xs: 'block',
              sm: 'none'
            },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth
            }
          },
          children: drawer
        })
      })]
    });
  };

  var renderCollapseList = function renderCollapseList(c, index) {
    // console.log('here: ', c)
    var parent = c.subcategories.find(function (item) {
      return item.slug === c.slug;
    });
    var pushedParent = parent !== undefined;

    if (!pushedParent) {
      c.subcategories.push({
        "name": t('home:allAbove'),
        "slug": c.slug,
        "parent_category": c.slug
      });
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomizedList, {
      category: category,
      index: index,
      t: t,
      name: t("home:".concat(c.slug)),
      subList: c.subcategories,
      filter: filter,
      handleFilterChange: handleFilterChange
    }, c.slug);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: isMobile ? "flex flex-col" : "flex gap-8",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: isMobile ? "flex flex-col w-full" : "w-3/12",
      children: isMobile ? renderMobileFilter() : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: "flex items-center pb-2 border-b mb-4",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
            icon: faSliders/* faSliders */.cR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'ml-2 font-semibold min-w-[32px]',
            children: t('home:filter')
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            variant: 'text',
            className: isMobile ? 'ml-auto w-auto' : 'ml-auto min-w-full',
            onClick: clearAll,
            children: t('home:clearall')
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "mb-4 ",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "font-semibold text-sm mb-2",
              children: t('home:filter_category')
            }), localCategories.map(function (c, index) {
              return type === 'Product' ? renderCollapseList(c, index) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
                label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                  className: 'text-sm',
                  children: t("home:".concat(c.slug))
                }),
                className: 'flex items-center -mb-1',
                control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                  checked: !!filter.categories ? filter.categories.includes(c.slug) : false,
                  onChange: function onChange(e) {
                    return handleFilterChange('categories', c.slug);
                  },
                  size: 'small',
                  className: 'text-primary-dark'
                })
              }, c.slug);
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "mb-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "font-semibold text-sm mb-2",
              children: t('home:amenities_BrandVerified')
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
              label: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                className: 'text-sm',
                children: [t('home:amenities_BrandVerified'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
                  icon: faCertificate/* faCertificate */.U,
                  className: 'ml-2 text-primary'
                })]
              }),
              className: 'flex items-center -mb-1',
              control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                checked: filter.brandVerified,
                onChange: function onChange(e) {
                  return handleFilterChange('brandVerified', !filter.brandVerified);
                },
                size: 'small',
                className: 'text-primary-dark'
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "mb-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "font-semibold text-sm mb-2",
              children: t('home:Brands')
            }), brands ? brands.map(function (b) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
                label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                  className: 'text-sm',
                  children: b.name
                }),
                className: 'flex items-center -mb-1',
                control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                  checked: !!filter.brands ? filter.brands.includes(b.id) : false,
                  onChange: function onChange(e) {
                    return handleFilterChange('brands', b.id);
                  },
                  size: 'small',
                  className: 'text-primary-dark'
                })
              }, b.slug);
            }) : null]
          }), type === 'Product' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "mb-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "font-semibold text-sm mb-2",
              children: t('home:filter_strainType')
            }), STRAIN_TYPES.map(function (t) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
                label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                  className: 'text-sm',
                  children: t.label
                }),
                className: 'flex items-center -mb-1',
                control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                  checked: !!filter.strainTypes ? filter.strainTypes.includes(t.value) : false,
                  onChange: function onChange(e) {
                    return handleFilterChange('strainTypes', t.value);
                  },
                  size: 'small',
                  className: 'text-primary-dark'
                })
              }, t.value);
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "mb-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "font-semibold text-sm mb-2",
              children: t('home:filter_priceRange')
            }), PRICE_RANGES.map(function (r) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
                label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                  className: 'text-sm',
                  children: "".concat(r.min === 0 ? t('home:under') : '$' + r.min).concat(r.min === 0 || r.max === 'Infinity' ? ' ' : ' - ').concat(r.max === 'Infinity' ? t('home:infinity') : '$' + r.max)
                }),
                className: 'flex items-center -mb-1',
                control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                  checked: !!filter.priceRanges ? filter.priceRanges.includes(r) : false,
                  onChange: function onChange(e) {
                    return handleFilterChange('priceRanges', r);
                  },
                  size: 'small',
                  className: 'text-primary-dark'
                })
              }, "".concat(String(r.min), "-").concat(String(r.max)));
            })]
          }), type === 'Product' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "mb-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "font-semibold text-sm mb-2",
              children: t('home:filter_weight')
            }), WEIGHTS.map(function (w) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
                label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                  className: 'text-sm',
                  children: w === 'Each' ? t('home:each') : w
                }),
                className: 'flex items-center -mb-1',
                control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                  checked: !!filter.weights ? filter.weights.includes(w) : false,
                  onChange: function onChange(e) {
                    return handleFilterChange('weights', w);
                  },
                  size: 'small',
                  className: 'text-primary-dark'
                })
              }, w);
            }) // <Checkbox
            //   checked={!!filter.brands ? filter.brands.includes(b.id) : false}
            //   onChange={e => handleFilterChange('brands', b.id)}
            //   size={'small'} className={'text-primary-dark'}
            // />
            ]
          })]
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "flex-grow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControl/* default */.Z, {
        fullWidth: true,
        size: 'small',
        className: 'mt-1',
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OutlinedInput/* default */.Z // label="Search this menu"
        , {
          placeholder: t('home:searchThisMenu'),
          id: 'menu-search',
          onChange: handleChangeSearchInput,
          onKeyDown: function onKeyDown(ev) {
            if (ev.key === 'Enter') {
              // Do code here
              handleSearch();
              ev.preventDefault();
            }
          },
          value: searchInput,
          endAdornment: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
            className: "cursor-pointer",
            icon: faSearch/* faSearch */.wn,
            onClick: handleSearch
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "flex py-4 items-center",
        children: [loaded ? "".concat(t('home:found'), " ").concat(filteredProducts.length) : '', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.Z, {
          value: sort,
          onChange: handleSortChange,
          size: 'small',
          className: "w-52 text-sm bg-white ml-auto",
          children: SORT_OPTIONS.map(function (option) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
              value: option,
              children: t("home:".concat(option.key))
            }, option.label);
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: isMobile ? "grid grid-cols-1" : "grid grid-cols-3 gap-3",
        children: filteredProducts.map(function (product) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductCard/* default */.Z, {
            data: product,
            baseUrl: baseUrl,
            type: type
          }, product.id + product.slug);
        })
      })]
    })]
  });
}

/***/ })

}]);